// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import dayjs from '/Users/yingben001/IdeaProjects/edatlink-box-admin/node_modules/.pnpm/dayjs@1.11.7/node_modules/dayjs';
import antdPlugin from '/Users/yingben001/IdeaProjects/edatlink-box-admin/node_modules/.pnpm/antd-dayjs-webpack-plugin@1.0.6_dayjs@1.11.7/node_modules/antd-dayjs-webpack-plugin/src/antd-plugin.js';

import isSameOrBefore from '/Users/yingben001/IdeaProjects/edatlink-box-admin/node_modules/.pnpm/dayjs@1.11.7/node_modules/dayjs/plugin/isSameOrBefore';
import isSameOrAfter from '/Users/yingben001/IdeaProjects/edatlink-box-admin/node_modules/.pnpm/dayjs@1.11.7/node_modules/dayjs/plugin/isSameOrAfter';
import advancedFormat from '/Users/yingben001/IdeaProjects/edatlink-box-admin/node_modules/.pnpm/dayjs@1.11.7/node_modules/dayjs/plugin/advancedFormat';
import customParseFormat from '/Users/yingben001/IdeaProjects/edatlink-box-admin/node_modules/.pnpm/dayjs@1.11.7/node_modules/dayjs/plugin/customParseFormat';
import weekday from '/Users/yingben001/IdeaProjects/edatlink-box-admin/node_modules/.pnpm/dayjs@1.11.7/node_modules/dayjs/plugin/weekday';
import weekYear from '/Users/yingben001/IdeaProjects/edatlink-box-admin/node_modules/.pnpm/dayjs@1.11.7/node_modules/dayjs/plugin/weekYear';
import weekOfYear from '/Users/yingben001/IdeaProjects/edatlink-box-admin/node_modules/.pnpm/dayjs@1.11.7/node_modules/dayjs/plugin/weekOfYear';
import isMoment from '/Users/yingben001/IdeaProjects/edatlink-box-admin/node_modules/.pnpm/dayjs@1.11.7/node_modules/dayjs/plugin/isMoment';
import localeData from '/Users/yingben001/IdeaProjects/edatlink-box-admin/node_modules/.pnpm/dayjs@1.11.7/node_modules/dayjs/plugin/localeData';
import localizedFormat from '/Users/yingben001/IdeaProjects/edatlink-box-admin/node_modules/.pnpm/dayjs@1.11.7/node_modules/dayjs/plugin/localizedFormat';
import duration from '/Users/yingben001/IdeaProjects/edatlink-box-admin/node_modules/.pnpm/dayjs@1.11.7/node_modules/dayjs/plugin/duration';

dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(advancedFormat);
dayjs.extend(customParseFormat);
dayjs.extend(weekday);
dayjs.extend(weekYear);
dayjs.extend(weekOfYear);
dayjs.extend(isMoment);
dayjs.extend(localeData);
dayjs.extend(localizedFormat);
dayjs.extend(duration);

dayjs.extend(antdPlugin);
